module.exports = __webpack_public_path__ + "img/webapp-mockup-heart-rate.1826e56b.png";